const ItemGenerator = require('../../../game_items/ItemGenerator');
const Hammer = require('../../../game_items/equipment/weapon/Hammer');
const HeavyBoots = require('../../../game_items/equipment/boots/HeavyBoots.js');
const HeavyHelmet = require('../../../game_items/equipment/helmet/HeavyHelmet.js');
const HeavyTorsoe = require('../../../game_items/equipment/torsoe/HeavyTorsoe.js');
const getMobEquipmenAssignmentFromBags = require('../mobs/getMobEquipmenAssignmentFromBags');

const voidwalker = (level) => {
  const handle = 'voidwalker';
  const types = ['amorphous', 'tanky', 'undead'];
  const AI_PRIORITIES = ['tank', 'dps_close', 'interference', 'support', 'dps_ranged'];
  const equipped_abilities = [
    { value: 'move' },
    { value: 'melee_attack' },
    { value: 'taunt' },
    { value: 'teleport' },
  ];
  const bags = [
    {
      value: {
        items: [
          ItemGenerator.getCavernsMobItem(Hammer, level),
          ItemGenerator.getCavernsMobItem(HeavyBoots, level),
          ItemGenerator.getCavernsMobItem(HeavyHelmet, level),
          ItemGenerator.getCavernsMobItem(HeavyTorsoe, level),
        ].map((item) => ({ value: item })),
      },
    },
  ];

  return {
    handle,
    types,
    level,
    getAbilityTrees: ((bound_level) => [
      {
        handle: 'voidwalker_abilities',
        abilities: {
          move: { handle: 'move', level: 1 },
          melee_attack: { handle: 'melee_attack', level: 1 },
          reflect_magic: {
            handle: 'reflect_magic',
            level: Math.min(10, Math.round(1 + bound_level / 2)),
            passive: true,
          },
          taunt: {
            handle: 'taunt',
            level: Math.min(10, Math.round(1 + bound_level / 2)),
          },
          teleport: {
            handle: 'teleport',
            level: Math.min(10, Math.round(1 + bound_level / 2)),
          },
        },
      },
    ]).bind(null, level),
    getBaseAttributes: ((bound_level) => ({
      learning: Math.round(3 + bound_level * 0.45 + Math.random() * 3),
      perception: Math.round(3 + bound_level * 0.4 + Math.random() * 3),
      mana: Math.round(3 + bound_level * 0.35 + Math.random() * 3),
      toughness: Math.round(6 + bound_level * 0.9 + Math.random() * 3),
      strength: Math.round(5 + bound_level * 0.65 + Math.random() * 3),
      willpower: Math.round(3 + bound_level * 0.4 + Math.random() * 3),
      dexterity: Math.round(3 + bound_level * 0.4 + Math.random() * 3),
    })).bind(null, level),
    getDefaultAIConfig: () => AI_PRIORITIES,
    xpValue: level * 180,
    drops_gold: true,
    drops_equipment: true,
    bags,
    build: {
      ai: {
        priorities: AI_PRIORITIES,
        settings: {
          chanceToSkipRoles: true,
          autoMove: true,
          waitForAPMP: false,
        },
      },
      ai_unit: true,
      equipment_assignment: getMobEquipmenAssignmentFromBags(bags),
      equipped_abilities,
      handle,
      level,
      team: 'black',
      types,
      unit: true,
    },
  };
};
module.exports = voidwalker;
